import { gql, useQuery } from '@apollo/client';
import { useEffect } from 'react';

const GET_NCAABB_MATCHUPS = gql`
  query GetNcaabbMatchups($useDummyDate: Boolean) {
    ncaabbMatchups(useDummyDate: $useDummyDate) {
      startTime
      oTeam
      team
      rank
      oRank
      month
      site
      streak
      ouStreak
      atsStreak
      oStreak
      oOuStreak
      oAtsStreak
      tournament
      school
      oSchool
      rest
      oRest
      playoffs
      line
      oLine
      date
      total
      wins
      losses
      oWins
      oLosses
      conference
      tournament
      oConference
      division
      oDivision
      pConference
      opConference
      pDivision
      opDivision
      avgAtsMargin
      avgOAtsMargin
      avgOuMargin
      avgOOuMargin
      avgPoints
      avgOPoints
      avgLine
      avgTotal
      avgOTotal
      avgRest
      avgORest
      avgAssistToTurnover
      avgOAssistToTurnover
      avgPace
      avgOPace
      oppAvgAtsMargin
      oppAvgOAtsMargin
      oppAvgOuMargin
      oppAvgOOuMargin
      oppAvgPoints
      oppAvgOPoints
      oppAvgLine
      oppAvgTotal
      oppAvgOTotal
      oppAvgRest
      oppAvgORest
      oppAvgAssistToTurnover
      oppAvgOAssistToTurnover
      oppAvgPace
      oppAvgOPace
      activeTrends {
        isAtsTrend
        isSuTrend
        isOuTrend
        atsWins
        atsLosses
        overs
        unders
        wins
        losses
        oPoints
        points
        trend
        trendDescription
        activeGames {
          activeDate
          activeOTeam
          activeTeam
        }
      }
    }
  }
`;

export const useGetNcaabbMatchups = (
    useDummyDate: boolean = false,
    skip: boolean = false,
    isLoggedIn: boolean = false
) => {
    const { data, loading, error, refetch } = useQuery(GET_NCAABB_MATCHUPS, {
        variables: { useDummyDate },
        skip,
        // fetchPolicy: 'network-only',
    });

    useEffect(() => {
        if (!skip && isLoggedIn) {
            refetch();
        }
    }, [isLoggedIn, useDummyDate, skip, refetch]);

    return { data, loading, error, refetch };
};